@let cta = data();

<a pai-button [appearance]="cta.appearance ?? 'primary'" [paiCmsLink]="cta.target">
  @if (targetTitle(); as title) {
    <span class="cdk-visually-hidden">{{ title }}:&ngsp;</span>
  }
  <span>{{ cta.label }}</span>
  @if (cta.icon && cta.icon.url) {
    <pai-svg [url]="cta.icon.url" />
  }
</a>
